// extracted by mini-css-extract-plugin
export default {"panelContainer":"panel_panelContainer__Gu91b"};